import { render, staticRenderFns } from "./FileTemplate.vue?vue&type=template&id=e37860ca&scoped=true&"
import script from "./FileTemplate.vue?vue&type=script&lang=js&"
export * from "./FileTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FileTemplate.vue?vue&type=style&index=0&id=e37860ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37860ca",
  null
  
)

export default component.exports